import { isObject } from '@/helpers/utils.ts';

import type { AbstractAdaptor, AnalyticsParams } from './abstract';

// ym(XXXXXX, 'reachGoal', target[, params[, callback]]);
declare function ym(id: number, reachGoal: string, target: string, params?: AnalyticsParams): void;

export class YandexAdaptor implements AbstractAdaptor {
  trackingId: number;

  init(options: { trackingId: number }) {
    this.trackingId = options.trackingId;
  }

  send(event: string, params?: AnalyticsParams) {
    if (!ym) {
      console.warn('yandex not loaded!!');
      return;
    }

    if (!event) return;

    ym(this.trackingId, 'reachGoal', event, isObject(params) ? (params as { [key: string]: any }) : { action: params });
  }
}
